var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal',[_c('modal-background',{attrs:{"show":_vm.showBackground}},[_c('modal-box',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hide),expression:"hide"}],attrs:{"title":_vm.title,"show":_vm.showBox}},[_c('v-app',{staticClass:"v-app-modal"},[_vm._t("default")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }